export const colors = {
  primary: '#0272ce',
  'primary-light': '#68BAFE',
  'primary-disabled': '#bebebe',

  'text-primary': '#4d4f5c',

  error: '#ff0000',

  bg: {
    0: '#fff',
    50: '#f8f8f8',
    100: '#f3f3f3',
    250: '#e9f5ff',
    200: '#eeeef0',
    300: '#dddddd',
    400: '#cfcfcf',
    500: '#979797',
    600: '#707070',
    800: '#3e3e3e',
  },
};
